import { FC, HTMLProps } from 'react';

import styled from 'styled-components';

import ScrollableContainer from '@components/Common/ScrollableContainer';

type TableProps = Omit<Partial<HTMLProps<HTMLTableElement>>, 'ref' | 'as'>;

const Table = styled.table`
    border-spacing: 0;
    border: 1px solid rgb(210, 210, 210);
    border-radius: var(--border-radius-m);

    overflow: hidden;
    max-width: var(--guide-content-width);
    margin-left: auto;
    margin-right: auto;
    margin: 0 auto;

    background: #fafafa;

    tr {
        th {
            padding: var(--indent-s) var(--indent-m);
            font-weight: 400;
            border: 1px solid var(--light-grey);
            border-top: none;
            border-left: none;
            white-space: nowrap;
            background: #f0f0f0;

            &:last-child {
                padding-left: 15px;
                border-right: none;
            }
        }
    }

    tbody {
        tr {
            border: 1px solid var(--light-grey);

            td {
                padding: var(--indent-m);
                border: 1px solid var(--light-grey);
                border-top: none;
                border-left: none;

                &:last-child {
                    border-right: none;
                }
            }

            td:last-of-type {
                padding-left: 15px;
            }

            &:last-child td {
                border-bottom: none;
            }
        }
    }
`;

const Component: FC<TableProps> = (props) => (
    <ScrollableContainer autoHeight universal autoHeightMin="100%" autoHeightMax="100%">
        <Table {...props} />
    </ScrollableContainer>
);

export { Component as Table };
